<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <!-- <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="区域：">
              <el-select v-model="query.area" placeholder="请选择" clearable size="small">
                <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="城市公司：">
              <el-select v-model="query.city" placeholder="请选择" clearable size="small">
                <el-option :label="item.name" :value="item.id" v-for="(item,index) in cityList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上级手机号：">
              <el-input v-model="query.keyword" placeholder="请输入上级手机号" clearable size="small" />
            </el-form-item>
          </el-form> -->
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <el-table-column label="排名" prop="ranking" align="center" width="60"></el-table-column>
          <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
          <el-table-column label="商品编号" prop="uuid" align="center"></el-table-column>
          <el-table-column label="聚水潭编号" prop="jushuitanCode" align="center"></el-table-column>
          <el-table-column label="售后数量" prop="goodsCount" sortable="custom" align="center" width="100"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'

export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        goodsCountSortSign:-1
      },
      selectItems: [],
      times: null,
      navList: [],
      navIndex: 0,
      today:''
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times={
      timeStart:`${this.today} 00:00:00`,
      timeEnd:`${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'goodsCount': 'goodsCountSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
     getTime(event) {
      this.times = JSON.parse(event)
      if(!this.times.ifUse){
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
     handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query={
        startIndex: 1,
        pageSize: 10,
        goodsCountSortSign:-1
      }
      this.times={
        timeStart:`${this.today} 00:00:00`,
        timeEnd:`${this.today} 23:59:59`,
      }
       this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
        this.navIndex = index;
        this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/goodsRanking/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query={...this.query}
      if(this.times && this.times.timeStart){
        query.startTime=this.times.timeStart
        query.endTime=this.times.timeEnd
      }
      this.listLoading = true
      return goodsOrderApi.getOrderAfterGoodsRanking(query).then(({ data }) => {
        // data.list = [
        //   {goodsName: '美白霜',order: 50,look: 50},
        //   {goodsName: '美白霜',order: 50,look: 50},
        //   {goodsName: '美白霜',order: 50,look: 50},
        //   {goodsName: '美白霜',order: 50,look: 50},
        //   {goodsName: '美白霜',order: 50,look: 50},
        // ]
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path,row,type) {
      if(type) {
        this.$router.push(`${path}?id=${row.id}&index=${type-1}`)
      }else{
        this.$router.push(`${path}?id=${row.id}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .filter-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0;
    .times {
      display: flex;
      align-items: center;
    }
    .btns {
      margin-bottom: 22px;
    }
  }
</style>
